import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Chip,
  FormLabel
} from "@mui/material";
import { Field } from "formik";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import DeckIcon from "@mui/icons-material/Deck";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import {
  resetTrackingData,
  Attendance,
  AttendanceProcess,
  Invoicegenerate,
  // empcontractcheck,
  empinvoicecheck,
  EmpMonthlyInv,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import { useDispatch } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendancePDF from "../../reports/AttendancePdf";
import { toast } from "react-hot-toast";
import { CheckinAutocomplete, Employeeautocomplete, MultiFormikOptimizedAutocomplete, TimesheetEmployeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { BikeScooterTwoTone } from "@mui/icons-material";
import InvoicePDF from "../../reports/Invoicetax";
import Invoice from "../../reports/Invoicetax";
import CashMemo from "../../reports/Cashmemopdf";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getConfig } from "../../../config";
import { FaFileExcel, FaFileImport, FaDownload } from "react-icons/fa";
import MonthlyAttendanceExcel from "../../reports/MonthlyAttendanceExcel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HourglassTopIcon from "@mui/icons-material/HourglassBottom";


const EditAttendance = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  var recID = params.id;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const EmpName = sessionStorage.getItem("EmpName");
  const CompanyID = sessionStorage.getItem("companyId");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

  // const is00123Subscription = ["001", "002", "003"].some(code =>
  //   SubscriptionCode?.endsWith(code)
  // );
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  // const InvoiceData = useSelector((state) => state.formApi.InvoicegenerateData);
  const Invoiceheader = useSelector(state => state.formApi.InvoiceHeaderData);
  const Invoicedetails = useSelector(state => state.formApi.InvoiceDetailData);

  console.log("InvoiceData", Invoiceheader, Invoicedetails);
  const AttendanceData = useSelector((state) => state.formApi.AttendanceData || []);
  console.log("AttendanceData", AttendanceData);
  const InvData = useSelector((state) => state.formApi.empinvoicedata || []);
  console.log(InvData, "--find InvData");
  
  const AttendanceMonthlyloading = useSelector((state) => state.formApi.AttendanceMonthlyloading);
  const empinvoiceMonthlyloading = useSelector((state) => state.formApi.empinvoiceMonthlyloading);
  console.log("AttendanceMonthlyloading", AttendanceMonthlyloading);

  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(31);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const [showPdf, setShowPdf] = React.useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const InvFlag = sessionStorage.getItem("InvoiceFlag");
  console.log("InvFlag", InvFlag);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const colors = tokens(theme.palette.mode);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [canDownload, setCanDownload] = useState(false);
  const [employeeURL, setEmployeeURL] = useState("");
  // const [selectedPro, setSelectedPro] = useState([{ RecordID: "187", Name: "General Regular Routine Activities" }]);
  const [selectedPro, setSelectedPro] = useState([]);
  const [selectedemployee, setSelectedEmployee] = useState([]);
  const [useCurrentEmp, setUseCurrentEmp] = useState(false);
  const [selectedProjcect, setselectedProjcect] = useState(0);
  const [footerHeight, setFooterHeight] = useState(60);
  const [isReady, setIsReady] = useState(false);
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);
  const employeeID = selectedemployee
    .map((Employee) => Employee.RecordID)
    .join(",");
  console.log(employeeID, "--employeeID");

  const EmpInvData = useSelector((state) => state.formApi.EmpMonthlyInvoiceData);
  console.log(EmpInvData, "--find EmpInvData");
  
  const EmpInvFlag = EmpInvData?.InvoiceFlag;
  const BillingType = EmpInvData?.BillingType;
  // const EmpInvFlag = "N";
  console.log("🚀 ~ EditAttendance ~ EmpInvFlag:", EmpInvFlag)



const [rowchange, setRowchange] = useState([]);
const [isGridLoading, setIsGridLoading] = useState(false);

useEffect(() => {
  console.log("--b4 newrows");
  
  const newRows = InvFlag === "Y" ? InvData : AttendanceData;
  setRowchange(newRows);
    console.log("--after newrows");

}, [InvData, AttendanceData, InvFlag]);

  useEffect(() => {
    dispatch(resetTrackingData());
  }, []);
  useEffect(() => {
    if (!FooterImg) return;

    const url = `${baseurl1}/uploads/images/${FooterImg}`;

    const img = new Image();
    img.src = url;

    img.onload = () => {
      const aspectRatio = img.height / img.width;

      const pageWidth = 595;
      const MAX_FOOTER_HEIGHT = 80; // 🔥 IMPORTANT

      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );

      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  // useEffect(() => {
  //   dispatch(resetTrackingData());
  // }, []);
  useEffect(() => {
    const savedEmpData = sessionStorage.getItem("attempData");
    const savedProData = sessionStorage.getItem("selectedPro");
    const savedSelf = sessionStorage.getItem("attuseCurrentEmp");
    const savedMonth = sessionStorage.getItem("attmonth");
    const savedYear = Number(sessionStorage.getItem("attyear"));

    const emp = savedEmpData ? JSON.parse(savedEmpData) : null;
    const pro = savedProData ? JSON.parse(savedProData) : null;

    const validPro = Array.isArray(pro)
      ? pro.filter((p) => p && p.RecordID)
      : [];


    let self;
    if (savedEmpData) {
      self = false;
    } else {
      self = true;
    }


    if (savedSelf !== null) {
      self = savedSelf === "true";
    }

    const month = savedMonth || currentMonthNumber;
    const year = savedYear || currentYear;


    setattUseCurrentEmp(self);
    setattempData(self ? null : emp);
    setSelectedPro(validPro);

    const projectIDString =
      validPro.length > 0 ? validPro.map((p) => p.RecordID).join(",") : "";

    const data = {
      Month: month,
      Year: year,
      EmployeeID: self ? EMPID : emp?.RecordID || "",
      ProjectID: projectIDString || 0,
      CompanyID,
      // UnAssignedproject: "N"
    };

    // dispatch(Attendance({ data }));
  }, []);


  const [flag, setflag] = useState("G");
  console.log("🚀 ~ EditAttendance ~ flag:", flag)
  const [invoiceflag, setInvoiceflag] = useState("");
  useEffect(() => {
    console.log("FLAG FROM API:", flag);
  }, [flag]);


  //For bulk upload import
  const fileInputRef = useRef(null);
  const [selectedMonth, setSelectedMonth] = useState("");

  const getMonthShort = (monthNumber) => {
    return new Date(0, monthNumber - 1).toLocaleString("en-US", {
      month: "short",
    });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      alert("Only Excel files allowed");
      return;
    }

    // Date format
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const dateKey = `${year}${month}${day}`;

    const fileName = `Attendance_Month_${dateKey}`;

    try {
      const formData = new FormData();

      //  Match API EXACTLY
      formData.append("excel_file", file);
      formData.append("Type", "bulk_process");   // 🔥 correct
      formData.append("file_name", fileName);
      formData.append("SubType", "M");           // 🔥 required

      console.log("Sending:", {
        excel_file: file.name,
        Type: "bulk_process",
        file_name: fileName,
        SubType: "M",
      });

      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/Attendance_Bulk_Processor.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      console.log("API Response:", result);

      if (result?.Status === "Y") {
        alert("Attendance uploaded successfully");
      } else {
        alert(result?.message || "Upload failed");
      }

    } catch (error) {
      console.error("Upload failed", error);
      alert("Upload failed");
    }

    e.target.value = null;
  };


  //File Download Process
  const handleDownload = async () => {
    try {
      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/ExcelFileDownload.php?file=Attendance_Month.xlsx",
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Attendance_Month.xlsx"); // file name

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file");
    }
  };




  // const handleGenerate = async (values) => {
  //   const res = await dispatch(
  //     Invoicegenerate({
  //       BillableMonth: values.attmonth,
  //       BillableYear: values.attyear,
  //       EmpRecID: attuseCurrentEmp ? EMPID : attempData.RecordID
  //     })
  //   );

  //   if (res?.payload?.Status === "Y") {
  //     setInvoiceflag(res?.payload?.Flag);
  //      setflag("D");     
  //     toast.success(res?.payload?.Message || "Invoice Generated Successfully!");
  //   } else {
  //     toast.error(res?.payload?.Message || "Failed to Generate Invoice");
  //   }
  // };

  const handleGenerate = async (values) => {

    console.log("selectedPro", selectedPro);
    console.log("AttInitialvalues", AttInitialvalues);
    const projectIDs = selectedPro?.length
      ? selectedPro.map(p => p.RecordID).join(",")
      : "";
    const res = await dispatch(
      Invoicegenerate({
        BillableMonth: values.attmonth,
        BillableYear: values.attyear,
        EmpRecID: attuseCurrentEmp ? EMPID : attempData?.RecordID,
        ProjectID: projectIDs || selectedProjcect || 0,
        CompanyID
      })
    );

    if (res?.payload?.Status === "Y") {
      toast.success(res?.payload?.Message || "Invoice Generated Successfully!");
      setflag("P");          // Change button → PRINT
      setInvoiceflag("");    // Clear invoiceFlag (optional)
    } else {
      toast.error(res?.payload?.Message || "Failed to Generate Invoice");
    }
  };


  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Attendance</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const AttColumn = [
    //     {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 60,
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.Status === "Week Off") {
          return <AlarmOffIcon color="primary" titleAccess="Week Off" />;
        }
        if (params.row.Status === "Holiday") {
          return <DeckIcon color="primary" titleAccess="Holiday" />;
        }
        if (params.row.Status === "Casual leave" || params.row.Status === "Sick leave" || params.row.Status === "Medical leave") {
          return <ExitToAppIcon color="primary" titleAccess="Leave" />;
        }
        return null;
      },
    },
    // {
    //   field: "EmployeeCheckInDate || MonthDate",
    //   headerName: "Check In Date",
    //   width: 130,
    //   headerAlign: "center",
    // },
    {
      field: "EmployeeCheckInDate",
      headerName: "In Date",
      width: 130,
      headerAlign: "center",
      align: 'center',
      valueGetter: (params) =>
        params.row.EmployeeCheckInDate || params.row.MonthDate,
    },

    {
      field: "EmployeeCheckInTime",
      headerName: "In Time",
      width: 130,
      headerAlign: "center",
      align: 'center'
    },
    // {
    //   field: "EmployeeCheckOutDate",
    //   headerName: "Out Date",
    //   width: 130,
    //   headerAlign: "center",
    // },
    {
      field: "EmployeeCheckOutTime",
      headerName: "Out Time",
      width: 130,
      headerAlign: "center",
      align: 'center'
    },
    {
      field: "NumberOfHoursWorked",
      headerName: "Worked Hours",
      width: 130,
      headerAlign: "center",
      align: 'center'
    },
    {
      field: "PermissionHours",
      headerName: "Permission (In Minutes)",
      width: 150,
      headerAlign: "center",
      align: 'center'
    },
    {
      field: "Status",
      headerName: "Status",
      width: 130,
      headerAlign: "center",
      align: 'center'
    },
    {
      field: "Commend",
      headerName: "Comments",
      width: 150,
      headerAlign: "center",
      align: 'center'
    },
  ];

  /***********Attendance ************/

  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  // const AttInitialvalues = {
  //   attmonth: sessionStorage.getItem("attmonth") || currentMonthNumber,
  //   attyear: Number(sessionStorage.getItem("attyear")) || currentYear,
  //   ProName: null,
  //   BillingType:BillingType || ""
  // };
  const AttInitialvalues = useMemo(() => ({
  attmonth: sessionStorage.getItem("attmonth") || currentMonthNumber,
  attyear: Number(sessionStorage.getItem("attyear")) || currentYear,
  ProName: null,
  BillingType: BillingType || ""
}), [BillingType, currentMonthNumber, currentYear]);
//   const AttInitialvalues = useMemo(() => ({
//   attmonth: sessionStorage.getItem("attmonth") || currentMonthNumber,
//   attyear: Number(sessionStorage.getItem("attyear")) || currentYear,
//   ProName: null,
//   BillingType: BillingType || ""
// }), []);

  useEffect(() => {
    if (!selectedPro?.length) return;

    const projIds = selectedPro.map(p => p.RecordID).join(",");

    const isGeneralRoutine = selectedPro.some(
      p => p.Name === "General Regular Routine Activities"
    );

    const queryPayload = {
      Query: {
        AccessID: isGeneralRoutine ? "2101" : "2115",
        ScreenName: "EMPLOYEETEAMS",
        Filter: isGeneralRoutine
          ? `ParentID=${EMPID}`
          : `ProjectID IN(${projIds}) AND CompanyID='${CompanyID}' GROUP BY RecordID`,
        Any: "",
        CompId: CompanyID,
      },
    };

    const fullURL = `${listViewurl}?data=${encodeURIComponent(
      JSON.stringify(queryPayload)
    )}`;

    setEmployeeURL(fullURL);
  }, [selectedPro, EMPID, CompanyID]);

  const [unassprjct, setUnassprjct] = useState(false);

  console.log(useCurrentEmp, "Selffff");
  const attendaceFnSave = async (values) => {
    const projectIDs = selectedPro?.length
      ? selectedPro.map(p => p.RecordID).join(",")
      : "";
    const data = {
      // Month: values.attmonth.toString(),
      // Year: values.attyear,
      // EmployeeID: attuseCurrentEmp ? EMPID : attempData.RecordID,
      // ProjectID: values?.ProName?.RecordID || 0,
      // CompanyID,
      Month: values.attmonth?.toString() ?? "",
      Year: values.attyear ?? "",
      // EmployeeID: useCurrentEmp
      //   ? EMPID
      //   : attempData?.RecordID ?? "",
      EmployeeID: attuseCurrentEmp
        ? EMPID
        : attempData?.RecordID ?? "",
      ProjectID: values?.ProName?.RecordID ?? "",
      CompanyID

    };
    setselectedProjcect(values?.ProName?.RecordID || 0);
    console.log(data, "=====DATA");

    // const response = await dispatch(Attendance({ data }));
    // if (response.payload.Status === "Y") {
    //   setflag(response.payload.Flag);
    //   console.log(response.payload.Flag, "====flag");
    // }
    if (InvFlag == "Y") {
            console.log("--calling if section");
 setIsGridLoading(true);  // ← ADD THIS
      try {
        const response = await dispatch(empinvoicecheck({ data }));
        if (response.payload.Status === "Y") {
          setflag(response.payload.Flag); //BEFORE IT WAS --> setflag(response.Flag) [undefined]
          console.log(response.payload.Flag, "====flag");

          if (is003Subscription) {
            const invoiceCheckRes = await dispatch(
              EmpMonthlyInv({
                data: {
                  CompanyID,
                  EmployeeID: attuseCurrentEmp ? EMPID : attempData.RecordID,
                  ProjectID: values?.ProName?.RecordID
                }
              })
            ).unwrap();

            if (invoiceCheckRes.InvoiceFlag === "Y") {
              // toast.success(invoiceCheckRes.Message);
               toast(invoiceCheckRes.Message, {
                icon: <HourglassTopIcon style={{ color: "#f59e0b" }} />
              });
            } else {
               toast.error(invoiceCheckRes.Message);

              // toast(invoiceCheckRes.Message, {
              //   icon: <HourglassTopIcon style={{ color: "#f59e0b" }} />
              // });

            }
          }
          // await dispatch(EmpMonthlyInv({ data: { CompanyID, EmployeeID: attuseCurrentEmp ? EMPID : attempData.RecordID, ProjectID: values?.ProName?.RecordID } }));
        }
      } catch (error) {
        console.error("Attendance save failed", error);
      }
      finally {
      setIsGridLoading(false);  // ← ADD THIS
    }
    }
    else {

      console.log("--calling else section");
       setIsGridLoading(true);  // ← ADD THIS
      setShowPdf(true);
    
      try {
        const response = await dispatch(Attendance({ data }));
        if (response.payload.Status === "Y") {

          // setflag(response.Flag);
          // console.log(response.Flag, "====flag");
          // await dispatch(EmpMonthlyInv({ data: { CompanyID, EmployeeID: attuseCurrentEmp ? EMPID : attempData.RecordID, ProjectID: values?.ProName?.RecordID } }));

          if (is003Subscription) {
            const invoiceCheckRes = await dispatch(
              EmpMonthlyInv({ data: { CompanyID, EmployeeID: attuseCurrentEmp ? EMPID : attempData.RecordID, ProjectID: values?.ProName?.RecordID } })
            ).unwrap();
            if (invoiceCheckRes.InvoiceFlag === "Y") {
              // toast.success(invoiceCheckRes.Message)
              toast(invoiceCheckRes.Message, {
                icon: <HourglassTopIcon style={{ color: "#f59e0b" }} />
              });
            }
            else if (invoiceCheckRes.InvoiceFlag === "N") {
               toast.error(invoiceCheckRes.Message)

              // toast(invoiceCheckRes.Message, {
              //   icon: <HourglassTopIcon style={{ color: "#f59e0b" }} />
              // });

            }
            else {
               toast.error(invoiceCheckRes.Message)

              // toast(invoiceCheckRes.Message, {
              //   icon: <HourglassTopIcon style={{ color: "#f59e0b" }} />
              // });

            }
               // Show invoice section only after Apply
    setCanShowInvoice(invoiceCheckRes.InvoiceFlag === "Y");
          }
        }
      } catch (error) {
        console.error("Attendance save failed", error);
      }
      finally {
      setIsGridLoading(false);  // ← ADD THIS
      
    }
    }

    // setButtonVisible(true)
  };

  // const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const safeAttendance = Array.isArray(AttendanceData) ? AttendanceData : [];
  // const gridRows =
  //    InvFlag === "Y" ? InvData : AttendanceData;

    // InvFlag == "Y"
    //   ? (Array.isArray(InvData) ? InvData : [])
    //   : (Array.isArray(AttendanceData) ? AttendanceData : []);
  const totalHours = safeAttendance
    .reduce((sum, row) => {
      // const hrs = parseFloat(row.NumberOfHoursWorked);
      const hrs = parseFloat(row.TotalWorkedTime);
      return sum + (isNaN(hrs) ? 0 : hrs);
    }, 0)
    .toFixed(2); // keep only 2 digits



  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [attempData, setattempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setattempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setattempData(null);
    }
    setattUseCurrentEmp(false);
  };

  useEffect(() => {
    sessionStorage.removeItem("attempData");
    setattempData(null);
  }, []);

  const [attuseCurrentEmp, setattUseCurrentEmp] = useState(true);
  const [withannexure, setwithannexure] = useState(true);
  const [contractFlag, setContractFlag] = React.useState(null);

  // const [proData, setproData] = useState(null);

  // const handleSelectionProjectChange = (newValue) => {
  //   if (newValue) {
  //     setproData(newValue);
  //   } else {
  //     setproData(null);
  //   }

  // };

  const isManagerUser = isManager === "1";
  const isSelf = attuseCurrentEmp === true;
  const isEmployeeSelected = !isSelf;

  // let canShowInvoice = false;

  // if (!isManagerUser) {
  //   // Non-manager
  //   canShowInvoice = EmpInvFlag === "Y";
  // } else {
  //   if (isSelf) {
  //     // Manager but Self checked
  //     canShowInvoice = EmpInvFlag === "Y";
  //   } else {
  //     // Manager selected employee
  //     canShowInvoice = EmpInvFlag === "Y";
  //   }
  // }


  
  const [canShowInvoice, setCanShowInvoice] = useState(false);

  useEffect(() => {
  setCanShowInvoice(EmpInvFlag === "Y");
}, [EmpInvFlag]);
// useEffect(() => {
//   let showInvoice = false;

//   if (!isManagerUser) {
//     // Non-manager
//     showInvoice = EmpInvFlag === "Y";
//   } else {
//     if (isSelf) {
//       // Manager but Self checked
//       showInvoice = EmpInvFlag === "Y";
//     } else {
//       // Manager selected employee
//       showInvoice = EmpInvFlag === "Y";
//     }
//   }

//   setCanShowInvoice(showInvoice);
// }, [EmpInvFlag, isManagerUser, isSelf]);


  const projectURL = useMemo(() => {
  return `${listViewurl}?data=${encodeURIComponent(
    JSON.stringify({
      Query: {
        AccessID: "2114",
        ScreenName: "Project",
        Filter: `ParentID=${CompanyID} AND EmployeeID=${EMPID}`,
        Any: "",
      },
    })
  )}`;
}, []);

  return (
    <React.Fragment>
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px",color:"#0000D1"}}>Monthly Attendance</Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {

            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                setattempData(null);
                sessionStorage.removeItem("attempData");
                setSelectedPro([]);
                sessionStorage.removeItem("selectedPro");
                setattUseCurrentEmp(true)
                sessionStorage.removeItem("attuseCurrentEmp")
                dispatch(resetTrackingData());
                setflag("G");
                setInvoiceflag("");
                setCanShowInvoice(false);
              }}
            >

              <Box
                display="grid"
                gridTemplateColumns="80px 80px 300px 200px 120px auto"
                columnGap={2}
                alignItems="center"
                padding={1}
              >

                {/* MONTH */}
                <TextField
                  variant="standard"
                  label="Month"
                  name="attmonth"
                  value={values.attmonth}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("attmonth", e.target.value);
                  }}
                  select
                  fullWidth
                  focused
                >
                  <MenuItem value="1">January</MenuItem>
                  <MenuItem value="2">February</MenuItem>
                  <MenuItem value="3">March</MenuItem>
                  <MenuItem value="4">April</MenuItem>
                  <MenuItem value="5">May</MenuItem>
                  <MenuItem value="6">June</MenuItem>
                  <MenuItem value="7">July</MenuItem>
                  <MenuItem value="8">August</MenuItem>
                  <MenuItem value="9">September</MenuItem>
                  <MenuItem value="10">October</MenuItem>
                  <MenuItem value="11">November</MenuItem>
                  <MenuItem value="12">December</MenuItem>
                </TextField>

                {/* YEAR */}
                <TextField
                  variant="standard"
                  label="Year"
                  type="number"
                  name="attyear"
                  value={values.attyear}
                  inputProps={{ min: "1900", max: "2100" }}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("attyear", e.target.value);
                  }}
                  focused
                  fullWidth
                />

                {/* PROJECT */}
                {isManager === "1" && (

                  // <MultiFormikOptimizedAutocomplete
                  //   name="ProName"
                  //   label="Project"
                  //   id="ProName"
                  //   value={selectedPro}
                  //   onChange={(e, newValue) => {
                  //     setFieldValue("ProName", newValue);
                  //     setSelectedPro(newValue);

                  //     if (newValue?.length)
                  //       sessionStorage.setItem("selectedPro", JSON.stringify(newValue));
                  //     else
                  //       sessionStorage.removeItem("selectedPro");

                  //     // Get selected project IDs
                  //     const projIds = newValue?.map((p) => p.RecordID).join(",");

                  //     // ✅ Check inside newValue array, 
                  //     const isGeneralRoutine = newValue?.some(
                  //       (p) => p.Name === "General Regular Routine Activities"
                  //     );

                  //     console.log(isGeneralRoutine, "----isGeneralRoutine");

                  //     const queryPayload = {
                  //       Query: {
                  //         AccessID: isGeneralRoutine ? "2101" : "2115",
                  //         ScreenName: "EMPLOYEETEAMS",
                  //         Filter: isGeneralRoutine
                  //           ? `parentID=${EMPID}`
                  //           : `ProjectID IN(${projIds}) AND CompanyID='${CompanyID}' GROUP BY RecordID`,
                  //         Any: "",
                  //         CompId: CompanyID,
                  //       },
                  //     };

                  //     const fullURL = `${listViewurl}?data=${encodeURIComponent(
                  //       JSON.stringify(queryPayload)
                  //     )}`;

                  //     setEmployeeURL(fullURL);
                  //   }}
                  //   url={`${listViewurl}?data=${encodeURIComponent(
                  //     JSON.stringify({
                  //       Query: {
                  //         AccessID: "2114",
                  //         ScreenName: "Project",
                  //         Filter: `ParentID=${CompanyID} AND EmployeeID=${EMPID}`,
                  //         Any: "",
                  //       },
                  //     })
                  //   )}`}
                  //   fullWidth
                  // />
                  // <CheckinAutocomplete
                  <TimesheetEmployeeautocomplete
                    fullWidth
                    name="ProName"
                    label={is003Subscription ? "Standard/Activities" : "Project"}
                    id="ProName"
                    value={values.ProName}
                    onChange={(newValue) => {
                      setFieldValue("ProName", newValue);
                      setSelectedPro(newValue);

                      // session storage
                      if (newValue)
                        sessionStorage.setItem("selectedPro", JSON.stringify(newValue));
                      else
                        sessionStorage.removeItem("selectedPro");

                      const projectId = newValue?.RecordID;

                      // ✅ Single select condition
                      const isGeneralRoutine =
                        newValue?.Name === "General Regular Routine Activities";

                      console.log(isGeneralRoutine, "----isGeneralRoutine");

                      const queryPayload = {
                        Query: {
                          AccessID: isGeneralRoutine ? "2101" : "2115",
                          ScreenName: "EMPLOYEETEAMS",
                          Filter: isGeneralRoutine
                            ? `parentID=${EMPID}`
                            // : `ProjectID=${projectId} AND CompanyID='${CompanyID}'GROUP BY RecordID`,
                             : `ProjectID=${projectId} AND CompanyID='${CompanyID}' AND RecordID NOT IN ('${EMPID}')`,
                        
                          Any: "",
                          CompId: CompanyID,
                        },
                      };

                      const fullURL = `${listViewurl}?data=${encodeURIComponent(
                        JSON.stringify(queryPayload)
                      )}`;

                      setEmployeeURL(fullURL);
                    }}
                    // url={`${listViewurl}?data=${encodeURIComponent(
                    //   JSON.stringify({
                    //     Query: {
                    //       AccessID: "2114",
                    //       ScreenName: "Project",
                    //       Filter: `ParentID=${CompanyID} AND EmployeeID=${EMPID}`,
                    //       Any: "",
                    //     },
                    //   })
                    // )}`}
                    url={projectURL}
                  />
                )}

                {isManager === "1" && (
                  // <Employeeautocomplete
                  <TimesheetEmployeeautocomplete
                    name="Employee"
                    label="Personnel"
                    id="Employee"
                    value={attempData}
                    onChange={(newValue) => {
                      setattempData(newValue);
                      setattUseCurrentEmp(false);
                       setCanShowInvoice(false); // hide until Apply
                      if (newValue)
                        sessionStorage.setItem("attempData", JSON.stringify(newValue));
                      else
                        sessionStorage.removeItem("attempData");
                    }}

                    url={employeeURL}
                    fullWidth
                  />
                )}
                {/* {isManager === "1" && (
                  <Employeeautocomplete
                    name="Employee"
                    label="Personnel"
                    id="Employee"
                    value={attempData}
                    onChange={async (newValue) => {
                      setattempData(newValue);
                      setattUseCurrentEmp(false);

                      if (newValue) {
                        try {
                          const response = await dispatch(
                            empcontractcheck({
                              data: {
                                EmployeeID: newValue.RecordID,
                                CompanyID: CompanyID,
                              },
                            })
                          ).unwrap(); // ✅ IMPORTANT

                          // response = { Status: "Y", Contract: "N" }
                          setContractFlag(response.Contract);

                          sessionStorage.setItem(
                            "attempData",
                            JSON.stringify(newValue)
                          );
                        } catch (err) {
                          console.error("Contract check failed", err);
                          setContractFlag(null);
                        }
                      } else {
                        setContractFlag(null);
                        sessionStorage.removeItem("attempData");
                      }
                    }}
                    url={employeeURL}
                    fullWidth
                  />
                )} */}

                {/* SELF CHECKBOX */}

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={attuseCurrentEmp}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setattUseCurrentEmp(checked);
                        setattempData(null);
                        // sessionStorage.setItem("attuseCurrentEmp", checked);

                      }}
                      color="primary"
                    />
                  }
                  label="Self"
                />
              </Box>
              {/* APPLY BUTTON */}

              <Stack direction="row"
                display="flex"
                padding={1}
                gap={2}
                justifyContent="end">
                <Button type="submit" variant="contained" color="secondary"

                >
                  APPLY
                </Button>
                <Button type="reset" variant="contained" color="error" sx={{ flexShrink: 0 }}>
                  RESET
                </Button>
                {showPdf && AttendanceData?.length > 0 && (
                  <PDFDownloadLink
                    document={
                      <AttendancePDF
                        data={AttendanceData}
                        filters={{
                          month: values.attmonth,
                          year: values.attyear,
                          employee: attempData?.Name || EmpName,
                          Imageurl: baseurl1,
                          HeaderImg: HeaderImg,
                          FooterImg: FooterImg,
                        }}
                        footerHeight={footerHeight}
                      />
                    }
                    fileName="Attendance_Report.pdf"
                    style={{ color: "#d32f2f", cursor: "pointer" }}
                  >
                    {({ loading }) =>
                      loading ? (
                        <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                      ) : (
                        <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                      )
                    }
                  </PDFDownloadLink>
                )}


                {showPdf && AttendanceData?.length > 0 && (

                  <FaFileExcel
                    size={20}
                    color="#1D6F42"
                    style={{ cursor: "pointer", }}
                    onClick={() =>
                      MonthlyAttendanceExcel(
                        AttendanceData,
                        {
                          month: values.attmonth,
                          year: values.attyear,
                          employee: attempData?.Name || EmpName,
                          // Imageurl: baseurl1,
                          // HeaderImg: HeaderImg,
                          // FooterImg: FooterImg,
                        }

                      )
                    }
                  />

                )}

                <FaFileImport
                  size={20}
                  title="Import"
                  color="#1D6F42"
                  style={{ cursor: "pointer" }}
                  onClick={() => fileInputRef.current.click()}
                />

                <input
                  type="file"
                  accept=".xlsx,.xls"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={(e) => handleFileUpload(e)}
                />

                <FaDownload
                  size={20}
                  title="download"
                  cursor='pointer'
                  onClick={handleDownload}
                />
              </Stack>


              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="500px"
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },

                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                    "& .weekoff-row": {
                      backgroundColor: "#ee7b8c96", // light red
                      color: "#b71c1c", // dark red text
                    },
                    "& .holiday-row": {
                      backgroundColor: "#c9f5cc", // light green
                      color: "#1b5e20", // dark green text
                    },
                    "& .leave-row": {
                      backgroundColor: "#f3cd9b", // light green
                      color: "#a16a03", // dark green text
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={rowchange}
                    // rows={gridRows}
                    columns={AttColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    
                    loading={isGridLoading || (InvFlag === "Y" ? empinvoiceMonthlyloading : AttendanceMonthlyloading)}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    // getRowClassName={(params) =>
                    //   params.indexRelativeToCurrentPage % 2 === 0
                    //     ? "odd-row"
                    //     : "even-row"
                    // }
                    getRowClassName={(params) => {
                      const status = params.row.Status;
                      if (status === "Week Off") return "weekoff-row";
                      if (status === "Holiday") return "holiday-row";
                      // if (status === "Casual leave" || status === "Sick leave" || status === "Medical leave") return "leave-row";
                      const leaveStatuses = [
                        "casual leave",
                        "sick leave",
                        "medical leave",
                      ];

                      if (leaveStatuses.includes(status?.trim().toLowerCase())) {
                        return "leave-row";
                      }

                      return params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row";
                    }}
                  />
                </Box>
              </Box>

              <Stack
                direction="row"
                padding={1}
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                {/* LEFT SIDE ITEMS */}
                <Box display="flex" alignItems="center" gap={2} sx={{ flexShrink: 0 }}>
                  <Chip
                    icon={<AlarmOffIcon color="primary" />}
                    label="Week Off"
                    variant="outlined"
                    sx={{ backgroundColor: "#f2acb7", borderColor: "#b91f1d", }}
                  />
                  <Chip
                    icon={<DeckIcon color="primary" />}
                    label="Holiday"
                    variant="outlined"
                    sx={{ backgroundColor: "#c9f5cc", borderColor: "#29d431", }}
                  />
                  <Chip
                    icon={<ExitToAppIcon color="primary" />}
                    label="Leave"
                    variant="outlined"
                    sx={{ backgroundColor: "#f3cd9b", borderColor: "#e79a0c73", }}
                  />
                </Box>

                {/* RIGHT SIDE BUTTONS */}


                {(canShowInvoice && InvData.length > 0) && (
                  <Box display="flex" alignItems="center" gap={2}>
                    <TextField
  fullWidth
  variant="standard"
  label="Billing Type"
  value={values.BillingType}
  id="BillingType"
  onBlur={handleBlur}
  onChange={handleChange}
  name="BillingType"
  error={!!touched.BillingType && !!errors.BillingType}
  helperText={touched.BillingType && errors.BillingType}
  focused
  select={!is003Subscription} // select only when false
  InputProps={{
    readOnly: is003Subscription,
  }}
>
  {!is003Subscription && (
    [
      <MenuItem key="CashMemo" value="CashMemo">
        Cash Memo
      </MenuItem>,
      <MenuItem key="GSTInvoice" value="GSTInvoice">
        GST Invoice
      </MenuItem>
    ]
  )}
</TextField>
                    {/* <TextField
    
                      select
                      fullWidth
                      variant="standard"
                      label="Billing Type"
                      value={values.BillingType}
                      id="BillingType"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="BillingType"
                      error={!!touched.BillingType && !!errors.BillingType}
                      helperText={touched.BillingType && errors.BillingType}
                      // required
                      focused
                      InputProps={{
                        inputProps:{readOnly : true}
                      }}
                    >
                      <MenuItem value="CashMemo">Cash Memo</MenuItem>
                      <MenuItem value="GSTInvoice">GST Invoice</MenuItem>
                    </TextField> */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={withannexure}
                          onChange={(e) => setwithannexure(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="With Annexure"
                    />

                    {/* {isManager === "1" && ( */}
                    <>
                      {(flag === "D" || invoiceflag === "D") && (
                        <Button variant="contained" disabled sx={{ flexShrink: 0 }}>
                          Generate Invoice
                        </Button>
                      )}

                      {flag === "G" && invoiceflag !== "D" && (
                        <Button variant="contained" sx={{ flexShrink: 0 }} onClick={() => handleGenerate(values)}>
                          Generate Invoice
                        </Button>
                      )}

                      {flag === "P" && invoiceflag !== "D" && (
                        <PDFDownloadLink

                          document={

                            values.BillingType === "CashMemo" ? (
                              <CashMemo
                                data={InvData}
                                invoice={Invoiceheader?.[0]}
                                detailData={Invoicedetails}
                                totalHours={totalHours}
                                logoUrl={"/Logo.png"}
                                headerUrl={"/Elitelogo.png"}
                                footerUrl={"/pdffooterimg.PNG"}
                                withannexure={withannexure}
                                // Type={values.BillingType}
                                filters={{
                                  Month: values.attmonth,
                                  Year: values.attyear,
                                  EmployeeID: attempData?.Name || EmpName,
                                  baseUrl: baseurl1
                                }}
                                footerHeight={footerHeight}
                              />
                            ) : (
                              <Invoice
                                data={InvData}
                                invoice={Invoiceheader?.[0]}
                                detailData={Invoicedetails}
                                totalHours={totalHours}
                                logoUrl={"/Logo.png"}
                                headerUrl={"/Elitelogo.png"}
                                footerUrl={"/pdffooterimg.PNG"}
                                qrUrl={"/QRimg.PNG"}
                                signUrl={"/SIGN.png"}
                                withannexure={withannexure}
                                // Type={values.BillingType}
                                filters={{
                                  Month: values.attmonth,
                                  Year: values.attyear,
                                  EmployeeID: attempData?.Name || EmpName,
                                  baseUrl: baseurl1
                                }}
                                footerHeight={footerHeight}

                              />
                            )}
                          fileName={`Invoice_Report_${attempData?.Name || EmpName}.pdf`}
                          style={{
                            textDecoration: "none",
                            display: "flex",
                            flexShrink: 0,
                            alignItems: "center"
                          }}

                        >
                          {({ loading }) => (
                            <Button variant="contained" sx={{ flexShrink: 0, whiteSpace: "nowrap" }} disabled={loading} >
                              Print Invoice
                            </Button>
                          )}
                        </PDFDownloadLink>
                      )}
                    </>
                    {/* )} */}

                    {/* <Button type="reset" variant="contained" color="error" sx={{ flexShrink: 0 }}>
                    RESET
                  </Button> */}
                    {/* {isManager === "1" && AttendanceData?.length > 0 && (
                      <PDFDownloadLink
                        document={
                          <AttendancePDF
                            data={AttendanceData}
                            totalHours={totalHours}
                            filters={{
                              Month: values.attmonth,
                              Year: values.attyear,
                              EmployeeID: attempData?.Name || EmpName,
                            }}
                          />
                        }
                        fileName={`Attendance_Report_${attempData?.Name || "Employee"}.pdf`}
                        style={{ color: "#d32f2f", cursor: "pointer" }}
                      >
                        {({ loading }) =>
                          loading ? (
                            <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                          ) : (
                            <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                          )
                        }
                      </PDFDownloadLink>
                    )} */}
                  </Box>
                )}
              </Stack>

            </form>
          )}
        </Formik>
      </Paper>
    </React.Fragment >
  );
};

export default EditAttendance;
